import React from 'react';

import PropTypes from 'prop-types';

import './SectionSubtitle.sass';

export const SectionSubtitle = ({ children, flex }) => (
  <div className={`section-subtitle  ${flex ? 'section-subtitle__flex' : ''}`}>{children}</div>
);

SectionSubtitle.propTypes = {
  children: PropTypes.node,
  flex: PropTypes.bool,
};
SectionSubtitle.defaultProps = {
  children: null,
  flex: false,
};
